import { useContext } from 'react'
import { z } from 'zod'

import MyProfileContext from '@/components/Context/MyProfileContext'
import { useRestMutation } from '@/lib/hook/tanstackQuery'
import { ApiMutationEndpoint } from '@/src/ApiMutationEndpoint'

// Mode expert Care de l'officine : ouvre les fonctionnalites avancees encore en developpement
// (aujourd'hui le planning du personnel). Stocke sur CompanyCare, il remonte dans le profil.
// Desactive par defaut : `=== true`, un profil pas encore charge vaut « desactive ».

/** Predicat pur, utilisable hors hook (fnDisplay des routes). */
export const isCareExpertModeEnabled = (dataMyProfile: any): boolean =>
  dataMyProfile?.selectCompanyDefault?.companyCare?.expertMode === true

export const useCareExpertMode = (): boolean => {
  const { dataMyProfile } = useContext(MyProfileContext)

  return isCareExpertModeEnabled(dataMyProfile)
}

const SaveCareExpertModeSchema = z.object({ expertMode: z.boolean() })

export type CareExpertModeInput = z.infer<typeof SaveCareExpertModeSchema>

export const useSaveCareExpertMode = () =>
  useRestMutation<{ success: boolean; expertMode: boolean }, Error, CareExpertModeInput>({
    ...ApiMutationEndpoint.CARE.ADMIN.SAVE_EXPERT_MODE,
    schema: SaveCareExpertModeSchema,
  })
